import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-brand-slate text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12 mb-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://cdn.durable.co/logos/17aBKcdoNPhqLxmYocv5nmo1wQqyuLYaKAVADtuA2a0FCRAnWvoQgTGFqwFk2SDz.png"
                alt="ITEC Groupe"
                className="h-10 object-contain"
              />
            </Link>
            <p className="text-sm text-gray-300 leading-relaxed mb-6">
              Société française indépendante de conseil en ingénierie et assistance technique, spécialisée en IT, génie civil et industrie.
            </p>
            <a
              href="https://linkedin.com/company/itec1"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-white/10 text-white hover:bg-brand-teal transition-colors duration-300"
            >
              <i className="ri-linkedin-fill text-xl"></i>
            </a>
          </div>

          {/* Navigation Links */}
          <div className="lg:col-span-3">
            <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
              {/* Company */}
              <div>
                <h3 className="text-base font-semibold mb-4 text-white">Entreprise</h3>
                <ul className="space-y-3">
                  <li>
                    <Link
                      to="/notre-adn"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      Notre ADN
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/expertises-realisations"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      Expertises & Réalisations
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/references"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      Références
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Support */}
              <div>
                <h3 className="text-base font-semibold mb-4 text-white">Support</h3>
                <ul className="space-y-3">
                  <li>
                    <Link
                      to="/faq"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      FAQ
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/contact"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      Contact
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/appointment"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      Réserver un rendez-vous
                    </Link>
                  </li>
                </ul>
              </div>

              {/* Legal */}
              <div>
                <h3 className="text-base font-semibold mb-4 text-white">Légal</h3>
                <ul className="space-y-3">
                  <li>
                    <Link
                      to="/privacy"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      Politique de confidentialité
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/mentions-legales"
                      className="text-sm text-gray-300 hover:text-brand-teal transition-colors duration-300"
                    >
                      Mentions légales & RGPD
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {new Date().getFullYear()} ITEC Groupe. Tous droits réservés.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}